// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"b21f2a543b372cb6a1e7","883":"abe4dfd26efd3e8bc235"}[chunkId] + ".js";
};